import { type ReactNode } from 'react'

type VideoAspectRatioBoxProps = {
  children: ReactNode
  className?: string
  aspectRatio?: '16/9' | '4/3' | '1/1'
  containerRef?: React.RefObject<HTMLDivElement>
}

const ASPECT_RATIO_CLASSES: Record<string, string> = {
  '16/9': 'aspect-video',
  '4/3': 'aspect-[4/3]',
  '1/1': 'aspect-square'
}

export const VideoAspectRatioBox = ({ children, className, containerRef, aspectRatio = '16/9' }: VideoAspectRatioBoxProps) => {
  return (
    <div
      ref={containerRef}
      className={`relative ${ASPECT_RATIO_CLASSES[aspectRatio]} w-full max-w-6xl overflow-hidden rounded-2xl bg-surface-dark shadow-lg ${className ?? ''}`}
    >
      {children}
    </div>
  )
}
